export default {"src":"/_next/static/media/leftBlack.0dca6c37.svg","height":2,"width":91,"blurWidth":0,"blurHeight":0};